import { handleActions } from 'redux-actions';
import {
    fetchTopUsdPriceRequest,
    fetchTopUsdPriceSuccess,
    fetchTopUsdPriceError,
} from '../actions/FetchCoinLists';

const defaultState = {
  data: [],
  isFetching: false,
  error: null,
};

// console.log('fetchTopUsdPriceSuccessss', fetchTopUsdPriceSuccess);
// console.log('fetchTopUsdPriceRequests', fetchTopUsdPriceRequest);
// console.log('fetchTopUsdPriceErrors', fetchTopUsdPriceError);
export default handleActions(
  {
    [fetchTopUsdPriceRequest](state) {
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    },
    [fetchTopUsdPriceSuccess](state, { payload }) {
      return {
        ...state,
        data: payload,
        isFetching: false,
        error: null,
      };
    },
    [fetchTopUsdPriceError](state, { payload }) {
      return {
        ...state,
        isFetching: false,
        error: payload,
      };
    },
  },
  defaultState,
);
